module.exports = "<crud-clerk-account-balance-curate></crud-clerk-account-balance-curate> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/crud/clerk-ledger/steps/transactions.account-balances.html
// module id = 2514
// module chunks = 86